import { ActionTypes } from '../../constants/ActionTypes';
import {
  IChangePayload,
  IGetReminder,
  IGetReminderFetch,
  IItem,
  IAddReminderParams,
} from '../../interfaces';

// Reminder
export const onGetReminder = (action: IGetReminder) => {
  return {
    type: ActionTypes.GET_REMINDER,
    payload: action,
  };
};

export const fetchReminderSuccess = (reminder: IGetReminderFetch) => {
  return {
    type: ActionTypes.FETCH_REMINDER_SUCCESS,
    payload: reminder,
  };
};

// chande reminder
export const onChangeReminder = (payload: IChangePayload) => {
  return {
    type: ActionTypes.CHANGE_REMINDER,
    payload: payload,
  };
};

export const onGetReminderReceivers = (action: any) => {
  return {
    type: ActionTypes.GET_REMINDER_RECEIVERS,
    payload: action,
  };
};

export const fetchGetReminderReceiversSuccess = (reminderReceivers: any[]) => {
  return {
    type: ActionTypes.FETCH_REMINDER_RECEIVERS_SUCCESS,
    payload: reminderReceivers,
  };
};

export const changeReminderStateItemValueWithType = (item: IItem) => {
  return {
    type: ActionTypes.CHANGE_REMINDER_STATE_ITEM_VALUE_WITH_TYPE,
    payload: item,
  };
};
export const onAddReminder = (payload: IAddReminderParams) => {
  return {
    type: ActionTypes.ADD_REMINDER,
    payload: payload,
  };
};
